module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_western_clothing-e310484e7f40e927c7abe8249f07f513.webp";